import { render, staticRenderFns } from "./VKAuth.vue?vue&type=template&id=173a9226&"
import script from "./VKAuth.vue?vue&type=script&lang=js&"
export * from "./VKAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports